// import Dashboard from "views/Dashboard/Dashboard";
// import UserProfile from "views/UserProfile/UserProfile";
// import TableList from "views/TableList/TableList";
// import Typography from "views/Typography/Typography";
// import Icons from "views/Icons/Icons";
// import Maps from "views/Maps/Maps";
// import Notifications from "views/Notifications/Notifications";
// import Upgrade from "views/Upgrade/Upgrade";

const adminRoutes = [
  { path: '/dashboard', name: 'Dashboard', icon: 'pe-7s-graph' },
  { path: '/tickets', name: 'Tiketi', icon: 'pe-7s-note2' },
  { path: '/clients', name: 'Klijenti', icon: 'pe-7s-users' },
  { path: '/devices', name: 'Uredjaji', icon: 'pe-7s-usb' },
  { path: '/services', name: 'Servisi', icon: 'pe-7s-tools' },
  { path: '/profiles', name: 'Admin/PM/Serviseri', icon: 'pe-7s-id' },
  { path: '/TicketsForReport', name: 'Izvestaj' , icon: 'pe-7s-albums'},
  { path: '/clientusers', name: 'Korisnici', icon: 'pe-7s-id' },
  //{ path: '/requests', name: 'Ostali Zahtevi', icon: 'pe-7s-note2' },
  { path: '/edit-profile', name: 'Profil', icon: 'pe-7s-user' },
  { path: '/register', name: 'Register', icon: 'pe-7s-add-user' },
  //{ path: '/deleted', name: 'Izbrisani', icon: 'pe-7s-close-circle' },
  { redirect: true, path: '/', to: '/login', name: 'Login' }
];

export default adminRoutes;
